export default __webpack_public_path__ + "static/media/ods17.c31a1d5e.svg";